<template>
  <div
    class="modal fade"
    :id="`book-${pipeline.pipeline_id}`"
    tabindex="-1"
    aria-labelledby="devModal"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="devModalLabel">
            <span v-if="booking.step === 1 && $route.name === 'job_uuid'"
              >Book interview with {{ pipeline.first_name }} {{ pipeline.last_name }}</span
            >
            <span v-if="booking.step === 1 && $route.name !== 'job_uuid'">Book interview</span>
            <span v-if="booking.step === 2">Interview request</span>
          </h5>

          <button
            @click="clearDates"
            ref="closeBookModal"
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="booking.step === 1" class="modal-body">
          <p style="margin-bottom: 25px;">
            We recommend that you suggest several alternative time slots and not earlier than within
            24 hours. The time zone is according to your user settings.
          </p>
          <div
            v-for="(date, index) in booking.selectedDates"
            class="form-group m-label-left book-date"
          >
            <!--             <input
              v-model="booking.selectedDates[index]"
              type="datetime-local"
              class="form-control mb-3"
              :min="minDate"
            /> -->
            <date-picker
              v-model="booking.selectedDates[index]"
              type="datetime"
              :value-type="'format'"
              :format="dateTimeFormat"
              :placeholder="dateTimeFormatPlaceHolder"
              :disabled-date="disablePastDates"
              :time-picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:30',
              }"
              clearable
            />
            <label>Suggested start time #{{ index + 1 }}</label>
            <button
              v-if="index === booking.selectedDates.length - 1"
              style="margin-left: 12px;"
              @click="addDates(index)"
              type="button"
              class="btn btn-outline"
            >
              <i class="fas fa-plus-circle"></i>
            </button>
            <button
              v-if="index > 0"
              style="margin-left: 12px;"
              @click="removeDate(index)"
              type="button"
              class="btn btn-outline-danger"
            >
              <i class="fas fa-times-circle"></i>
            </button>
          </div>
          <div class="form-group m-label-left book-date">
            <select v-model="booking.selectedLocation" class="form-control">
              <option value="2">
                Face-to-face
              </option>
              <option value="1">
                Video
              </option>
              <option value="3">
                Phone call
              </option>
            </select>
            <label for="book-location">Location</label>
          </div>

          <div v-if="booking.selectedLocation === '2'" class="form-group m-label-left book-date">
            <input
              v-model="booking.selectedAddress"
              id="book-address"
              type="text"
              class="form-control"
            />
            <label for="book-address">Address</label>
          </div>

          <div v-if="booking.selectedLocation === '1'" class="form-group m-label-left book-date">
            <textarea
              v-model="booking.videoInstructions"
              id="book-instructions"
              rows="3"
              class="form-control"
            ></textarea>
            <label for="book-instructions">Instructions to join</label>
          </div>
          <div class="form-group m-label-left">
            <textarea
              v-model="booking.info"
              id="book-info"
              rows="4"
              class="form-control"
            ></textarea>
            <label for="book-info">Information about meeting</label>
          </div>
        </div>
        <div v-else class="modal-body">
          <p>
            Thank you, we have received your request for an interview with
            <strong
              >{{ pipeline.first_name ? pipeline.first_name : getCandidateById.first_name }}
              {{ pipeline.last_name ? pipeline.last_name : getCandidateById.last_name }}.</strong
            >
          </p>
        </div>
        <div v-if="booking.step === 1" class="modal-footer text-center justify-content-center">
          <button @click="bookDate" type="button" class="btn btn-primary">
            Request meeting
          </button>
          <button
            @click="clearDates"
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
        </div>
        <div v-else class="modal-footer text-center justify-content-center">
          <button
            @click="booking.step = 1"
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  props: {
    pipeline: {
      type: Object,
    },
  },
  components: {
    DatePicker,
  },

  data: () => ({
    selectedTimeConfirm: '',
    booking: {
      step: 1,
      selectedDates: [''],
      defaultDateTime: '',
      selectedLocation: '1',
      selectedAddress: '',
      videoInstructions: '',
      info: '',
      defaultDateTime: '',
    },
  }),
  methods: {
    /*     getTomorrowAtTenAM() {
      const now = new Date();
      now.setDate(now.getDate() + 1); // Move to tomorrow
      now.setHours(10, 0, 0, 0); // Set time to 10:00:00.000

      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');

      this.booking.defaultDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
      this.booking.selectedDates.push(`${year}-${month}-${day}T${hours}:${minutes}`);
    }, */

    /*   getTomorrowAtTenAM() {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      d.setHours(10, 0, 0, 0);
      return formatDate(d, this.dateTimeFormat);
    }, */

    disablePastDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },

    addDates(currentIndex) {
      if (this.booking.selectedDates.length < 10) {
        this.booking.selectedDates.push('');
        this.booking.selectedDates[currentIndex + 1] = this.booking.defaultDateTime;
      }
    },
    removeDate(index) {
      this.booking.selectedDates.splice(index, 1);
    },
    clearDates() {
      this.booking.step = 1;
      this.booking.selectedLocation = '1';
      this.booking.videoInstructions = '';
      this.booking.info = '';
      this.booking.selectedDates = [''];
      this.createAddress();
      this.booking.selectedDates = this.booking.selectedDates.map(date => date);
    },

    bookDate() {
      const tz = this.getUserProfile.timezone;
      const userFormat = this.getUserProfile.format_date;

      // Match UI format to moment.js parsing format
      const formatMap = {
        'YY-MM-DD': 'YY-MM-DD HH:mm',
        'YY/MM/DD': 'YY/MM/DD HH:mm',
        'DD-MM-YY': 'DD-MM-YY HH:mm',
        'DD/MM/YY': 'DD/MM/YY HH:mm',
        'MM-DD-YY': 'MM-DD-YY HH:mm',
        'MM/DD/YY': 'MM/DD/YY HH:mm',
      };

      const fmt = formatMap[userFormat] || 'DD-MM-YY HH:mm';

      // Convert each to a string in UTC
      const selectedDatesUTC = this.booking.selectedDates.map(slot => {
        return moment.tz(slot, fmt, tz).format('YYYY-MM-DD HH:mm:ss');
      });

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/admin/interview/create`,
          {
            pipeline_id: this.pipeline.pipeline_id,
            location: Number(this.booking.selectedLocation),
            address: this.booking.selectedAddress,
            instructions: this.booking.videoInstructions,
            information: this.booking.info,
            timeslots_data: selectedDatesUTC, // now it's array of strings
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.booking.step++;
          this.$emit('update');
          this.booking.selectedDates = [''];
          this.booking.selectedLocation = '1';
          this.booking.videoInstructions = '';
          this.booking.info = '';
          this.createAddress();
        })
        .catch(err => {
          console.error('Booking error:', err);
        });
    },

    createAddress() {
      if (this.pipeline.employer_address.address) {
        this.booking.selectedAddress = `${this.pipeline.employer_address.address}`;
      }
      if (this.pipeline.employer_address.postal_code) {
        this.booking.selectedAddress =
          this.booking.selectedAddress +
          `, ${this.pipeline.employer_address.postal_code} ${this.pipeline.employer_address.city}, ${this.pipeline.employer_address.country}`;
      }
    },
  },

  computed: {
    ...mapGetters(['getUserProfile', 'getCandidateById']),
    minDate() {
      return new Date().toISOString().slice(0, 16);
    },
    dateTimeFormat() {
      // assume getUserProfile.format_date is something like "MM-dd-yyyy"
      return `${this.getUserProfile.format_date} HH:mm`;
      // or for 12-hour clock with AM/PM:
      // return `${this.getUserProfile.format_date} hh:mm a`
    },
    dateTimeFormatPlaceHolder() {
      // assume getUserProfile.format_date is something like "MM-dd-yyyy"
      return `${this.getUserProfile.format_date} hh:mm`;
      // or for 12-hour clock with AM/PM:
      // return `${this.getUserProfile.format_date} hh:mm a`
    },
  },
  mounted() {
    this.createAddress();
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.book-date {
  display: flex;
  margin-bottom: 20px;
  .form-control {
    margin-bottom: 0 !important;
  }
  .btn-outline {
    border: 1px solid rgba(0, 0, 0, 0.2);
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
    i {
      color: #5bb75b;
    }
    &:hover {
      background-color: #5bb75b;
      i {
        color: #fff;
      }
    }
  }
}
</style>
